import styled, { DefaultTheme, useTheme } from 'styled-components';
import { paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { DynamicText } from '../../../../app-kit/components/DynamicText/DynamicText';
import { ColorVariant, mapColorVariantToBarStyle } from '../../../../helpers/colorVariant';

const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingHelper('twoExtraSmall')};
`;

const LegendColorDot = styled.div<{ color: ColorVariant; theme: DefaultTheme }>`
  display: inline-block;
  height: 12px;
  width: 12px;
  border-radius: 100%;
  background-color: ${({ color, theme }) => mapColorVariantToBarStyle(color, theme).barColor};
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacingHelper('extraSmall')};
`;

const LegendLabel = styled(DynamicText)`
  color: ${paletteHelper('textSecondary')};
`;

export type LegendEntry = {
  label: {
    text: string;
  }[];
  colorVariant: ColorVariant;
};

export const DemographicsLegend = ({ legendEntries }: { legendEntries: LegendEntry[] }) => {
  const theme = useTheme();

  return (
    <LegendContainer>
      {legendEntries.map((legendEntry) => (
        <LegendItem key={legendEntry.label[0].text}>
          <LegendColorDot color={legendEntry.colorVariant} theme={theme} />
          <LegendLabel dynamicTexts={legendEntry.label} variant="body02" variantBold="body02Bold" />
        </LegendItem>
      ))}
    </LegendContainer>
  );
};
